export default [
    {
        path: 'relatorio-material',
        component: () => import(
            /* webpackChunkName: 'cadastro-relatorio-material' */
            '@/views/cadastro/relatorio-material/Index'
        ),
        redirect: 'relatorio-material/index',
        children: [
            {
                name: 'cadastro-relatorio-material-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-relatorio-material' */
                    '@/views/cadastro/relatorio-material/List.vue'
                ),
            },
        ],
    },
]